<template>
  <artmisads-modal
    v-model:open="open"
    :title="t('seller.common.notice')"
    :width="560"
    @cancel="onCancel"
  >
    <p v-if="record?.status === 'INCOMING'" class="cancel-text">{{ t('seller.accBonusProgram.cancelIncomingMsg') }}</p>
    <template v-else>
      <p class="cancel-text">{{ t('seller.accBonusProgram.cancelActiveLine1') }}</p>
      <p class="cancel-text cancel-text-gap">{{ t('seller.accBonusProgram.cancelActiveLine2') }}</p>
      <p class="cancel-text">
        {{ t('seller.accBonusProgram.cancelActiveLine3', { date: record?.cancelEffectiveDate || '—' }) }}
      </p>
    </template>

    <template #footer>
      <artmisads-button type="primary" :loading="confirmLoading" @click="onConfirm">
        {{ t('seller.accBonusProgram.cancelProgramBtn') }}
      </artmisads-button>
    </template>
  </artmisads-modal>
</template>

<script setup>
import { ref, defineExpose, defineEmits } from 'vue';
import { useI18n } from 'vue-i18n';
import { message } from 'ant-design-vue';
import { accBonusProgramApi } from '@/server/index';
import moment from 'moment';

const { t } = useI18n();
const emit = defineEmits(['success']);

const open = ref(false);
const confirmLoading = ref(false);
const record = ref(null);

const onCancel = () => {
  open.value = false;
};

const onConfirm = async () => {
  if (!record.value?.programId) return;

  confirmLoading.value = true;
  try {
    const res = await accBonusProgramApi.cancelProgram({ programId: record.value.programId });
    if (res?.success === false) {
      message.error(res?.message || res?.error || t('seller.msg.operationFailed'));
      return;
    }
    message.success(t('seller.accBonusProgram.cancelSuccess'));
    open.value = false;
    emit('success');
  } catch {
    message.error(t('seller.msg.operationFailed'));
  } finally {
    confirmLoading.value = false;
  }
};

const show = async (row) => {
  record.value = row;
  open.value = true;
  if (record.value.status !== 'INCOMING') {
    const res = await accBonusProgramApi.getProgramCancelPreview({ programId: record.value.programId });
    record.value.cancelEffectiveDate = moment(res.data.effectiveCancelDateInEpochMills).format('YYYY-MM-DD');
  }
};

defineExpose({ show });
</script>

<style lang="less" scoped>
.cancel-text {
  margin: 0;
  font-family: Sora, sans-serif;
  font-size: 14px;
  line-height: 22px;
  color: #0f0629;
  letter-spacing: 0.3px;
}

.cancel-text-gap {
  margin: 10px 0;
}
</style>
